"use strict";

function _defineProperty2(e, r, t) { return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DataProcessor = void 0;
var _utilities = require("../utilities"),
  _types = require("./types");
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    _defineProperty(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var DataProcessor = /*#__PURE__*/function () {
  function DataProcessor() {
    _classCallCheck(this, DataProcessor);
    var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : null,
      b = 1 < arguments.length ? arguments[1] : void 0;
    _defineProperty(this, "cleanupInterval", void 0), _defineProperty(this, "packageInfo", void 0), this.cleanupInterval = a, this.packageInfo = b;
  }
  return _createClass(DataProcessor, [{
    key: "mutUpdateData",
    value: function mutUpdateData(a) {
      var b = a.infoData,
        c = a.visitorCode,
        d = a.mutData,
        e = a.dataItem,
        _this$dereferenceData = this.dereferenceData(d, c),
        f = _this$dereferenceData.visitorReference,
        g = _this$dereferenceData.data,
        h = _this$dereferenceData.isReference;
      this.packageInfo.isServer && h && !d[f] && (b.mappingIdentifiers && delete b.mappingIdentifiers[c], delete d[c], f = c);
      var i = this.cleanupInterval ? Date.now() + this.cleanupInterval : 0;
      switch (e.data.type) {
        case _types.KameleoonData.CustomData:
          {
            this.updateCustomData({
              expirationTime: i,
              customData: e,
              visitorCode: f,
              mutData: g
            });
            break;
          }
        case _types.KameleoonData.PageView:
          {
            this.updatePageView({
              expirationTime: i,
              pageView: e,
              visitorCode: f,
              mutData: g
            });
            break;
          }
        case _types.KameleoonData.Conversion:
          {
            this.updateConversion({
              expirationTime: i,
              conversion: e,
              visitorCode: f,
              mutData: g
            });
            break;
          }
        case _types.KameleoonData.VisitsData:
          {
            this.updateVisitsData({
              expirationTime: i,
              visitsData: e,
              visitorCode: f,
              mutData: g
            });
            break;
          }
        default:
          this.updateCommonData({
            expirationTime: i,
            commonData: e,
            visitorCode: f,
            mutData: g
          });
      }
      return i;
    }
  }, {
    key: "mutCleanupData",
    value: function mutCleanupData(a, b) {
      if (!this.cleanupInterval) return null;
      var c = 0;
      for (var _i = 0, _Object$entries = Object.entries(a); _i < _Object$entries.length; _i++) {
        var _ref = _Object$entries[_i];
        var _ref2 = _slicedToArray(_ref, 2);
        var e = _ref2[0];
        var f = _ref2[1];
        if ("string" == typeof f) {
          this.removeReference({
            mutData: a,
            visitorCode: e,
            linkedVisitor: f,
            infoData: b
          });
          continue;
        }
        var g = 0;
        for (var _i2 = 0, _Object$keys = Object.keys(f); _i2 < _Object$keys.length; _i2++) {
          var _a = _Object$keys[_i2];
          var _b = _a;
          var _c = void 0;
          switch (_b) {
            case _types.KameleoonData.CustomData:
            case _types.KameleoonData.PageView:
            case _types.KameleoonData.Conversion:
              {
                _c = this.deleteNestedExpiredField(f, _b);
                break;
              }
            default:
              _c = this.deleteExpiredField(f, _b);
          }
          (!g || _c && _c < g) && (g = _c);
        }
        if (!!Object.keys(a[e]).length) (!c || g && g < c) && (c = g);else if (delete a[e], this.packageInfo.isServer) {
          var d;
          null !== (d = b.mappingIdentifiers) && void 0 !== d ? d : b.mappingIdentifiers = {}, delete b.mappingIdentifiers[e];
        }
      }
      return c;
    }
  }, {
    key: "mutAddUnsentData",
    value: function mutAddUnsentData(a) {
      var b = a.mutData,
        c = a.visitorCode,
        d = a.dataType;
      var e = b.unsentData[c];
      if (!e || !e.length) b.unsentData[c] = [d];else {
        var _a2 = new Set(_toConsumableArray(e));
        _a2.add(d), b.unsentData[c] = Array.from(_a2);
      }
    }
  }, {
    key: "createReference",
    value: function createReference(a) {
      var b = a.mutData,
        c = a.visitorCode,
        d = a.linkedVisitor;
      b[d] = c;
    }
  }, {
    key: "removeReference",
    value: function removeReference(a) {
      var b = a.mutData,
        c = a.visitorCode,
        d = a.linkedVisitor,
        e = a.infoData;
      this.packageInfo.isServer && !b[d] && (delete b[c], e.mappingIdentifiers && delete e.mappingIdentifiers[c]);
    }
  }, {
    key: "updatePageView",
    value: function updatePageView(a) {
      var b = a.visitorCode,
        c = a.mutData,
        d = a.pageView,
        e = a.expirationTime;
      var f = d.data,
        g = c[b] && _types.KameleoonData.PageView in c[b] && f.urlAddress in c[b][_types.KameleoonData.PageView],
        h = {
          expirationTime: e,
          visitorCode: b,
          data: c,
          key: _types.KameleoonData.PageView,
          nestedKey: f.urlAddress,
          value: f
        };
      if (g) {
        var _a3 = c[b][_types.KameleoonData.PageView][f.urlAddress],
          _d = _a3.timestamps;
        var _iterator = _createForOfIteratorHelper(_d),
          _step;
        try {
          var _loop = function _loop() {
            var a = _step.value;
            var b = a.time;
            if (f.timestamps.some(function (a) {
              var c = a.time;
              return c === b;
            })) return 1; // continue
            var c = f.timestamps.findIndex(function (a) {
              var c = a.time;
              return c >= b;
            });
            -1 === c ? f.timestamps.push(a) : f.timestamps.splice(c, 0, a);
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            if (_loop()) continue;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.updateNestedField(h);
      } else this.createNestedField(h);
    }
  }, {
    key: "updateCustomData",
    value: function updateCustomData(a) {
      var b = a.visitorCode,
        c = a.customData,
        d = a.mutData,
        e = a.expirationTime;
      var f = c.data,
        g = d[b] && _types.KameleoonData.CustomData in d[b],
        h = {
          expirationTime: e,
          visitorCode: b,
          data: d,
          key: _types.KameleoonData.CustomData,
          nestedKey: f.index.toString(),
          value: f
        };
      g ? this.updateNestedField(h) : this.createNestedField(h);
    }
  }, {
    key: "updateConversion",
    value: function updateConversion(a) {
      var b = a.conversion,
        c = a.mutData,
        d = a.visitorCode,
        e = a.expirationTime;
      var f = b.data,
        g = c[d] && _types.KameleoonData.Conversion in c[d],
        h = {
          expirationTime: e,
          visitorCode: d,
          data: c,
          key: _types.KameleoonData.Conversion,
          nestedKey: f.id.toString(),
          value: f
        };
      g ? this.updateNestedField(h) : this.createNestedField(h);
    }
  }, {
    key: "updateVisitsData",
    value: function updateVisitsData(a) {
      var b = a.visitorCode,
        c = a.mutData,
        d = a.visitsData,
        e = a.expirationTime;
      var f = d.data,
        g = c[b] && _types.KameleoonData.VisitsData in c[b],
        h = {
          expirationTime: e,
          data: c,
          key: _types.KameleoonData.VisitsData,
          value: f,
          visitorCode: b
        };
      if (g) {
        var _a4 = c[b][_types.KameleoonData.VisitsData];
        _a4.visits.forEach(function (a) {
          _utilities.Utilities.insertInOrderedListMutably({
            list: f.visits,
            element: a,
            order: _utilities.Order.Ascending
          });
        }), this.updateField(_objectSpread(_objectSpread({}, h), {}, {
          value: _objectSpread(_objectSpread({}, f), {}, {
            visits: f.visits
          })
        }));
      } else this.createField(h);
    }
  }, {
    key: "updateCommonData",
    value: function updateCommonData(a) {
      var b = a.visitorCode,
        c = a.mutData,
        d = a.commonData,
        e = a.expirationTime;
      var f = d.data,
        g = c[b] && f.type in c[b],
        h = {
          expirationTime: e,
          data: c,
          key: f.type,
          visitorCode: b,
          value: f
        };
      g ? this.updateField(h) : this.createField(h);
    }
  }, {
    key: "dereferenceData",
    value: function dereferenceData(a, b) {
      return "string" == typeof a[b] ? {
        visitorReference: a[b],
        data: a,
        isReference: !0
      } : {
        visitorReference: b,
        data: a,
        isReference: !1
      };
    }
  }, {
    key: "deleteExpiredField",
    value: function deleteExpiredField(a, b) {
      if (!a) return 0;
      var c = b,
        d = a[c].expirationTime < Date.now();
      return d ? (delete a[c], 0) : a[c].expirationTime;
    }
  }, {
    key: "deleteNestedExpiredField",
    value: function deleteNestedExpiredField(a, b) {
      if (!a[b]) return 0;
      var c = a[b];
      var d;
      for (var _i3 = 0, _Object$entries2 = Object.entries(c); _i3 < _Object$entries2.length; _i3++) {
        var _ref3 = _Object$entries2[_i3];
        var _ref4 = _slicedToArray(_ref3, 2);
        var e = _ref4[0];
        var f = _ref4[1];
        if (!f) continue;
        var _a5 = f.expirationTime < Date.now();
        _a5 ? delete c[e] : (!d || f.expirationTime < d) && (d = f.expirationTime);
      }
      return Object.keys(c).length || delete a[b], d;
    }
  }, {
    key: "updateField",
    value: function updateField(a) {
      var b = a.key,
        c = a.value,
        d = a.data,
        e = a.visitorCode,
        f = a.expirationTime;
      d[e][b] = _objectSpread(_objectSpread({}, c), {}, {
        expirationTime: f
      });
    }
  }, {
    key: "createField",
    value: function createField(a) {
      var b = a.key,
        c = a.value,
        d = a.data,
        e = a.visitorCode,
        f = a.expirationTime;
      d[e] = _objectSpread(_objectSpread({}, d[e]), {}, _defineProperty2({}, b, _objectSpread(_objectSpread({}, c), {}, {
        expirationTime: f
      })));
    }
  }, {
    key: "updateNestedField",
    value: function updateNestedField(a) {
      var b = a.key,
        c = a.nestedKey,
        d = a.value,
        e = a.data,
        f = a.visitorCode,
        g = a.expirationTime;
      e[f][b][c] = _objectSpread(_objectSpread({}, d), {}, {
        expirationTime: g
      });
    }
  }, {
    key: "createNestedField",
    value: function createNestedField(a) {
      var b;
      var c = a.key,
        d = a.nestedKey,
        e = a.value,
        f = a.data,
        g = a.visitorCode,
        h = a.expirationTime;
      f[g] = null !== (b = f[g]) && void 0 !== b && b[c] ? _objectSpread(_objectSpread({}, f[g]), {}, _defineProperty2({}, c, _objectSpread(_objectSpread({}, f[g][c]), {}, _defineProperty2({}, d, _objectSpread(_objectSpread({}, e), {}, {
        expirationTime: h
      }))))) : _objectSpread(_objectSpread({}, f[g]), {}, _defineProperty2({}, c, _defineProperty2({}, d, _objectSpread(_objectSpread({}, e), {}, {
        expirationTime: h
      }))));
    }
  }]);
}();
exports.DataProcessor = DataProcessor;